import type { ApplicationStatus } from '~domains/commerce/transactions/entities/application';

import type { MultiSelectOption } from '~shared/ui/multi-select-filter';

export const APPLICATION_STATUS_OPTIONS: MultiSelectOption[] = [
  { value: 'WAITING_DOWN_PAYMENT', label: 'Down payment required' },
  { value: 'SUCCESS', label: 'Success' },
] satisfies { value: ApplicationStatus; label: string }[];
